export function isExternalLink(link) {
    return link.externalRoute !== undefined;
}
